/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidityEnum } from './ValidityEnum';
import {
    ValidityEnumFromJSON,
    ValidityEnumFromJSONTyped,
    ValidityEnumToJSON,
    ValidityEnumToJSONTyped,
} from './ValidityEnum';
import type { Status111Enum } from './Status111Enum';
import {
    Status111EnumFromJSON,
    Status111EnumFromJSONTyped,
    Status111EnumToJSON,
    Status111EnumToJSONTyped,
} from './Status111Enum';
import type { StealerLeakSeverityEnum } from './StealerLeakSeverityEnum';
import {
    StealerLeakSeverityEnumFromJSON,
    StealerLeakSeverityEnumFromJSONTyped,
    StealerLeakSeverityEnumToJSON,
    StealerLeakSeverityEnumToJSONTyped,
} from './StealerLeakSeverityEnum';
import type { OwnerEnum } from './OwnerEnum';
import {
    OwnerEnumFromJSON,
    OwnerEnumFromJSONTyped,
    OwnerEnumToJSON,
    OwnerEnumToJSONTyped,
} from './OwnerEnum';
import type { TwoFaStatusEnum } from './TwoFaStatusEnum';
import {
    TwoFaStatusEnumFromJSON,
    TwoFaStatusEnumFromJSONTyped,
    TwoFaStatusEnumToJSON,
    TwoFaStatusEnumToJSONTyped,
} from './TwoFaStatusEnum';

/**
 * 
 * @export
 * @interface StealerLeak
 */
export interface StealerLeak {
    /**
     * 
     * @type {number}
     * @memberof StealerLeak
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    identifier: string;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    url?: string | null;
    /**
     * 
     * @type {OwnerEnum}
     * @memberof StealerLeak
     */
    owner?: OwnerEnum;
    /**
     * 
     * @type {Date}
     * @memberof StealerLeak
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof StealerLeak
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof StealerLeak
     */
    device?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    readonly deviceInfo: string;
    /**
     * 
     * @type {number}
     * @memberof StealerLeak
     */
    domain?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    readonly domainName: string;
    /**
     * 
     * @type {number}
     * @memberof StealerLeak
     */
    service?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    readonly serviceName: string;
    /**
     * 
     * @type {boolean}
     * @memberof StealerLeak
     */
    isMobile?: boolean;
    /**
     * 
     * @type {ValidityEnum}
     * @memberof StealerLeak
     */
    validity?: ValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StealerLeak
     */
    readed?: boolean;
    /**
     * 
     * @type {TwoFaStatusEnum}
     * @memberof StealerLeak
     */
    twoFaStatus?: TwoFaStatusEnum;
    /**
     * 
     * @type {StealerLeakSeverityEnum}
     * @memberof StealerLeak
     */
    severity?: StealerLeakSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    impact?: string;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    recommendation?: string;
    /**
     * 
     * @type {number}
     * @memberof StealerLeak
     */
    assignedTo?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StealerLeak
     */
    readonly assignedToDetails: string;
    /**
     * 
     * @type {Status111Enum}
     * @memberof StealerLeak
     */
    status?: Status111Enum;
}



/**
 * Check if a given object implements the StealerLeak interface.
 */
export function instanceOfStealerLeak(value: object): value is StealerLeak {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('deviceInfo' in value) || value['deviceInfo'] === undefined) return false;
    if (!('domainName' in value) || value['domainName'] === undefined) return false;
    if (!('serviceName' in value) || value['serviceName'] === undefined) return false;
    if (!('assignedToDetails' in value) || value['assignedToDetails'] === undefined) return false;
    return true;
}

export function StealerLeakFromJSON(json: any): StealerLeak {
    return StealerLeakFromJSONTyped(json, false);
}

export function StealerLeakFromJSONTyped(json: any, ignoreDiscriminator: boolean): StealerLeak {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'identifier': json['identifier'],
        'password': json['password'],
        'url': json['url'] == null ? undefined : json['url'],
        'owner': json['owner'] == null ? undefined : OwnerEnumFromJSON(json['owner']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'device': json['device'] == null ? undefined : json['device'],
        'deviceInfo': json['device_info'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'domainName': json['domain_name'],
        'service': json['service'] == null ? undefined : json['service'],
        'serviceName': json['service_name'],
        'isMobile': json['is_mobile'] == null ? undefined : json['is_mobile'],
        'validity': json['validity'] == null ? undefined : ValidityEnumFromJSON(json['validity']),
        'readed': json['readed'] == null ? undefined : json['readed'],
        'twoFaStatus': json['two_fa_status'] == null ? undefined : TwoFaStatusEnumFromJSON(json['two_fa_status']),
        'severity': json['severity'] == null ? undefined : StealerLeakSeverityEnumFromJSON(json['severity']),
        'impact': json['impact'] == null ? undefined : json['impact'],
        'recommendation': json['recommendation'] == null ? undefined : json['recommendation'],
        'assignedTo': json['assigned_to'] == null ? undefined : json['assigned_to'],
        'assignedToDetails': json['assigned_to_details'],
        'status': json['status'] == null ? undefined : Status111EnumFromJSON(json['status']),
    };
}

  export function StealerLeakToJSON(json: any): StealerLeak {
      return StealerLeakToJSONTyped(json, false);
  }

  export function StealerLeakToJSONTyped(value?: Omit<StealerLeak, 'id'|'created_at'|'updated_at'|'device_info'|'domain_name'|'service_name'|'assigned_to_details'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identifier': value['identifier'],
        'password': value['password'],
        'url': value['url'],
        'owner': OwnerEnumToJSON(value['owner']),
        'device': value['device'],
        'domain': value['domain'],
        'service': value['service'],
        'is_mobile': value['isMobile'],
        'validity': ValidityEnumToJSON(value['validity']),
        'readed': value['readed'],
        'two_fa_status': TwoFaStatusEnumToJSON(value['twoFaStatus']),
        'severity': StealerLeakSeverityEnumToJSON(value['severity']),
        'impact': value['impact'],
        'recommendation': value['recommendation'],
        'assigned_to': value['assignedTo'],
        'status': Status111EnumToJSON(value['status']),
    };
}

